import cn from "classnames";
import { Link } from "gatsby";
import React, { useEffect, useState } from "react";

import Icon from "components/Icon";

import * as styles from "./Search.module.scss";

const Search = ({
  open,
  onClose,
}) => {
  const [query, setQuery] = useState("");
  const [searchData, setSearchData] = useState();
  const [results, setResults] = useState();

  useEffect(() => {
    async function fetchData() {
      const response = await fetch("/albums.json");
      let albums = await response.json();
      setSearchData(
        albums.map(({
          artist,
          host,
          number,
          played_on,
          title,
          tracks,
          year,
        }) => ({
          // These fields are used for displaying results.
          artist,
          host: host.display_name,
          number,
          title,
          tracks: tracks?.map(({name}) => name),
          year,
          // The search property is what's actually quried in the search.
          search: JSON.stringify([
            artist,
            host.display_name,
            `#${number}`,
            played_on.slice(0,10),
            title,
            tracks?.map(({name}) => name),
            `@${year}`,
          ].join(";")).toLowerCase(),
        }))
        .reverse()
      )
    };
    fetchData();
  }, []);

  useEffect(() => {
    searchData && setResults(searchData.filter(a => (
      a.search.includes(query.toLowerCase()))
    ));
  }, [query, searchData]);

  return (
    <div className={cn(styles.el, {
      [styles[`open`]]: open,
    })}>
      <input placeholder="search" type="search" value={query} onChange={e => setQuery(e.target.value)} className={styles.query} />
      <button onClick={() => onClose(false)} className={styles.close}>
        <Icon icon="close_white" />
      </button>
      {results && query && (
        <ul className={styles.results}>
          {results.map(result => (
            <li className={styles.result} key={result.number}>
              <Link to={`/${result.number}`}>
                #{result.number} {result.title}
                <span className={styles.sub}>{result.artist} • {result.year} • {result.host}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Search;
